/* =========================================================================
   EP Nutrition – Zuletzt angesehene Produkte
   Datei: assets/ep-recently-viewed.js
   
   Funktion:
   - Auf Produktseiten: speichert das aktuelle Produkt in localStorage
   - Auf Kategorieseiten: zeigt die zuletzt angesehenen Produkte in der Sidebar
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'ep_recently_viewed';
  var MAX_ITEMS = 10;

  /* ===== Tracker: aktuelles Produkt in localStorage speichern ===== */
  function trackCurrentProduct() {
    // Menü v2 (25.10.2026): alle ld+json-Blöcke durchsuchen (der erste ist WebSite) –
    // erster Block mit @type ProductGroup oder Product und Namen; Preis notfalls aus hasVariant[0].offers.
    var blocks = document.querySelectorAll('script[type="application/ld+json"]');
    if (!blocks.length) return;

    // Versuche das aktuelle Produkt aus dem ld+json zu lesen
    try {
      var data = null;
      var all = [];
      for (var bi = 0; bi < blocks.length; bi++) {
        var parsed;
        try { parsed = JSON.parse(blocks[bi].textContent); } catch (pe) { continue; }
        var cands = Array.isArray(parsed) ? parsed : (parsed && parsed['@graph'] ? parsed['@graph'] : [parsed]);
        for (var ci = 0; ci < cands.length; ci++) {
          var c = cands[ci];
          if (c && (c['@type'] === 'ProductGroup' || c['@type'] === 'Product') && c.name) {
            all.push(c);
            if (!data) data = c;
          }
        }
      }
      if (!data) return;
      if (!data.offers && Array.isArray(data.hasVariant) && data.hasVariant[0] && data.hasVariant[0].offers) {
        data.offers = data.hasVariant[0].offers;
      }

      var product = {
        title: data.name || '',
        url: window.location.pathname,
        image: findImage(data, all),
        price: '',
        priceCompare: '',
        vendor: data.brand && data.brand.name ? data.brand.name : ''
      };

      // Preis aus Offers extrahieren
      if (data.offers) {
        var offer = Array.isArray(data.offers) ? data.offers[0] : data.offers;
        if (offer.priceSpecification) {
          var spec = Array.isArray(offer.priceSpecification) ? offer.priceSpecification[0] : offer.priceSpecification;
          if (spec.price) product.price = formatPrice(spec.price, spec.priceCurrency);
        } else if (offer.price) {
          product.price = formatPrice(offer.price, offer.priceCurrency);
        }
      }

      if (!product.title || !product.url) return;

      saveProduct(product);
    } catch (e) {
      // Stille Fehler - kein User-Impact
    }
  }

  /* Bild aus ld+json (25.10.2026): String direkt, Array → erstes Element, Objekt → .url/.contentUrl/.src.
     Früher wurde bei einem String data.image[0] gelesen (nur das erste Zeichen). Ergebnis: absolute https-URL oder ''. */
  function normalizeImage(img) {
    if (Array.isArray(img)) img = img[0];
    if (img && typeof img === 'object') img = img.url || img.contentUrl || img.src || '';
    if (typeof img !== 'string') return '';
    img = img.trim();
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    else if (img.charAt(0) === '/') img = window.location.origin + img;
    else if (img.indexOf('http://') === 0) img = 'https://' + img.slice(7);
    return isValidImage(img) ? img : '';
  }

  /* Bild finden (25.10.2026): Der ProductGroup-Block hat oft kein image. Reihenfolge:
     1. image des gewählten Blocks, 2. image eines weiteren Product-Blocks mit gleichem Namen,
     3. og:image:secure_url / og:image (Hauptbild), 4. Bild der ersten Variante (hasVariant[0].image). */
  function findImage(data, all) {
    var img = normalizeImage(data.image);
    for (var i = 0; !img && i < all.length; i++) {
      if (all[i] !== data && all[i].name === data.name) img = normalizeImage(all[i].image);
    }
    if (!img) {
      var og = document.querySelector('meta[property="og:image:secure_url"]') || document.querySelector('meta[property="og:image"]');
      if (og) img = normalizeImage(og.getAttribute('content'));
    }
    if (!img && Array.isArray(data.hasVariant) && data.hasVariant[0]) img = normalizeImage(data.hasVariant[0].image);
    return img;
  }

  /* Offensichtlich ungültige gespeicherte Bilder (alte Einträge mit nur einem Zeichen) */
  function isValidImage(img) {
    return typeof img === 'string' && img.length >= 10 && img.indexOf('/') !== -1;
  }

  function formatPrice(value, currency) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    var symbol = currency === 'EUR' ? '€' : (currency || '€');
    return num.toFixed(2).replace('.', ',') + ' ' + symbol;
  }

  function saveProduct(product) {
    var items = getStoredItems();
    
    // Doppelte entfernen (anhand URL)
    items = items.filter(function (item) {
      return item.url !== product.url;
    });
    
    // Neues Item nach vorne
    items.unshift(product);
    
    // Auf MAX limitieren
    if (items.length > MAX_ITEMS) {
      items = items.slice(0, MAX_ITEMS);
    }
    
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      // localStorage voll oder deaktiviert
    }
  }

  function getStoredItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var items = JSON.parse(raw);
      if (!Array.isArray(items)) return [];
      // Einträge mit ungültigem Bild als „ohne Bild“ behandeln (werden beim nächsten Speichern bereinigt)
      return items.filter(function (item) { return item && typeof item === 'object'; }).map(function (item) {
        if (!isValidImage(item.image)) item.image = '';
        return item;
      });
    } catch (e) {
      return [];
    }
  }

  /* ===== Renderer: Zuletzt-Box in Sidebar befüllen ===== */
  function renderRecentBox() {
    var box = document.querySelector('[data-ep-recent-box]');
    if (!box) return;

    var list = box.querySelector('[data-ep-recent-list]');
    if (!list) return;

    var maxItems = parseInt(box.getAttribute('data-ep-recent-count'), 10) || 5;
    var items = getStoredItems();

    // Aktuelle Seite aus Liste filtern (User soll nicht das aktuelle Produkt sehen)
    var currentUrl = window.location.pathname;
    items = items.filter(function (item) {
      return item.url !== currentUrl;
    });

    if (items.length === 0) {
      box.hidden = true;
      return;
    }

    items = items.slice(0, maxItems);

    var html = items.map(function (item) {
      var imageHtml = item.image
        ? '<img src="' + escapeHtml(thumbUrl(item.image, 128)) + '" srcset="' + escapeHtml(thumbUrl(item.image, 128)) + ' 1x, ' + escapeHtml(thumbUrl(item.image, 256)) + ' 2x" alt="' + escapeHtml(item.title) + '" class="ep-cat-sidebar__img" loading="lazy" decoding="async" />'
        : '<span class="ep-cat-sidebar__img-fallback">' + escapeHtml(item.title.charAt(0).toUpperCase()) + '</span>';

      var vendorHtml = item.vendor
        ? '<span class="ep-cat-sidebar__vendor">' + escapeHtml(item.vendor) + '</span>'
        : '';

      var priceHtml = item.price
        ? '<span class="ep-cat-sidebar__price"><span class="ep-cat-sidebar__price-now">' + escapeHtml(item.price) + '</span></span>'
        : '';

      return (
        '<a href="' + escapeHtml(item.url) + '" class="ep-cat-sidebar__item">' +
          '<span class="ep-cat-sidebar__img-wrap">' + imageHtml + '</span>' +
          '<span class="ep-cat-sidebar__info">' +
            '<span class="ep-cat-sidebar__name">' + escapeHtml(item.title) + '</span>' +
            vendorHtml +
            priceHtml +
          '</span>' +
        '</a>'
      );
    }).join('');

    list.innerHTML = html;
    box.hidden = false;
  }

  /* Shopify-CDN-Bild auf Breite w verkleinern (Sidebar-Bild ist 64 px groß, Original oft 1920 px) */
  function thumbUrl(u, w) {
    try {
      var x = new URL(u, window.location.href);
      if (/(^|\.)cdn\.shopify\.com$/.test(x.hostname) || x.pathname.indexOf('/cdn/shop/') === 0) {
        x.searchParams.set('width', String(w));
        return x.toString();
      }
    } catch (e) {}
    return u;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ===== Init ===== */
  function init() {
    // Auf Produktseite: tracken
    if (document.body.classList.contains('template-product') || 
        window.location.pathname.indexOf('/products/') !== -1) {
      trackCurrentProduct();
    }
    
    // Auf Kategorieseite: rendern
    renderRecentBox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();